<div class="article-item align-h align-start cursor-pointer" (click)="viewDetails()">
   <div class="article-thumbnail">
      <img [src]="article.thumbnailImage ? article.thumbnailImage : '/assets/images/logo_ITI-small.svg'" [alt]="article?.title"  />
      <img  *ngIf="isYoutubeVedio" class="play-btn" src="/assets/images/RedPlay.svg"> 
   </div>
    <div class="stretch article-thumbnail-content">
       <p class="tab-item-year-month">{{article?.month}}, {{article?.year}}</p>
       <p class="tab-item-title">{{article?.title}}</p>
       <p *ngIf="!hideDecription" class="tab-item-short-description">{{article?.shortDesc}}</p>
    </div>
 </div>